module.exports = __webpack_public_path__ + "static/media/pic20-min.04ef6986.jpg";